const CardFooter = {
	baseStyle: {
		display: "flex",
		width: "100%",
		fontSize: '0.6em'
	},
};

export const CardFooterComponent = {
	components: {
		CardFooter,
	},
};
